export default "src/content/themes/association-wordpress-theme/img/ac0d2b45be441cdd4a2a0edfd39c8645.png";